import React, { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

const PDFViewer = ({ file, containerRef }) => {
  const [isMounted, setIsMounted] = useState(false);
  const [numPages, setNumPages] = useState(null);
  const [width, setWidth] = useState(-1);
  const [error, setError] = useState(null);

  const onDocumentLoadSuccess = ({ numPages }) => {
    console.log('PDF loaded successfully. Pages:', numPages);
    setNumPages(numPages);
  };

  const onDocumentLoadError = (error) => {
    console.error('Error loading PDF:', error);
    console.error('PDF URL:', file);
    setError(`Failed to load PDF: ${error.message || 'Unknown error'}`);
  };

  useEffect(() => {
    console.log('PDFViewer mounting with file:', file);
    setIsMounted(true);
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
  }, [file]);

  useEffect(() => {
    if (containerRef && containerRef.current) {
      const newWidth = containerRef.current.clientWidth;
      console.log('Container width:', newWidth);
      setWidth(newWidth);
    }
  }, [containerRef]);

  if (!isMounted) {
    return <div className="pdf-loading"><p>Initializing...</p></div>;
  }

  if (error) {
    return (
      <div className="pdf-error">
        <p>{error}</p>
        <p style={{ fontSize: '0.9em', marginTop: '10px' }}>Please check browser console for details.</p>
      </div>
    );
  }

  return (
    <Document
      file={{
        url: file,
        httpHeaders: {
          'Accept': 'application/pdf'
        },
        withCredentials: false
      }}
      onLoadSuccess={onDocumentLoadSuccess}
      onLoadError={onDocumentLoadError}
      loading={
        <div className="pdf-loading">
          <p>Loading PDF...</p>
        </div>
      }
      error={
        <div className="pdf-error">
          <p>Failed to load PDF. Please try again later.</p>
        </div>
      }
      options={{
        cMapUrl: `//unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
        cMapPacked: true,
        standardFontDataUrl: `//unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`
      }}
    >
      {numPages && Array.from(new Array(numPages), (_, index) => (
        <Page
          key={`page_${index + 1}`}
          pageNumber={index + 1}
          renderAnnotationLayer={false}
          renderTextLayer={false}
          width={width > 0 ? width : undefined}
          loading={
            <div className="pdf-loading">
              <p>Loading page {index + 1}...</p>
            </div>
          }
        />
      ))}
    </Document>
  );
};

export default PDFViewer;
